import React, { useState } from "react"
import { Card, Container } from "reactstrap"
import { useNavigate } from "react-router-dom"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import TrackOrder from "pages/Dealer-order2/trackOrderModal"
import Feedback from "pages/Dealer-order2/feedbackModal"
import ProductReview from "pages/Dealer-order2/reviewModal"
import slr36 from "../../assets/images/product/slr36.png";



const OrderDetails = props => {
  document.title = "Order Details | DMS"
  const navigate = useNavigate();

  const [modal1, setModal1] = useState(false);
  const [modal2, setModal2] = useState(false);
  const [modal3, setModal3] = useState(false);

  const toggleViewModal = (value) => {
    setModal1(!modal1)
  }; 
  const toggleViewModalForFeedback= () => setModal2(!modal2)
  const toggleModalForReview= () => setModal3(!modal3)

  return (
    <React.Fragment>
        <TrackOrder isOpen={modal1} toggle={toggleViewModal}/>
          <Feedback isOpen={modal2} toggle={toggleViewModalForFeedback}/>
          <ProductReview isOpen={modal3} toggle={toggleModalForReview}/>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Order" breadcrumbItem="Order Details" />
          <div className="d-flex justify-content-between">
            <div>
              <span>Ordered on 22 Nov 2023 | Order # 171-251459864-0231</span>
            </div>
            <div>
              <a 
                className="text-primary fs-5"
                onClick={()=>{
                    navigate(`/customer/invoice`)
                 }}
              >
                Invoice <i className="bx bx-chevron-down"></i>
              </a>
            </div>
          </div>
          <Card className="mt-1" >
            <div className="d-flex justify-content-between" style={{padding:"20px"}}>
                <div className="d-flex justify-content-between" style={{width:"35%"}}>
                    <div>
                        <p style={{fontSize:"16px",marginBottom:"10px"}}><b>Shipping Address</b></p>
                        <span>Ajit Kumar Khatua</span>
                        <br />
                        <span>A/103 Berhampur</span>
                        <br />
                        <span>Near Narayan Gym</span>
                        <br />
                        <span>Cuttack,Odisha,754112</span>
                        <br />
                        <span>India</span>
                    </div>
                    <div>
                        <p style={{fontSize:"16px",marginBottom:"10px"}}><b>Payment Method</b></p>
                        <span>Amazon Pay balance</span>
                        <br/>
                        <i className="bx bxl-visa text-primary" style={{fontSize:"35px"}}></i>

                    </div>

                </div>
                <div style={{marginRight:"40px",width:"25%"}}>
                    <p style={{fontSize:"16px",marginBottom:"10px"}}><b>Order Summary</b></p>
                     <div className="d-flex justify-content-between">
                         <span>Items Subtotal: </span>
                         <span>₹ 14600.00</span>
                     </div>
                     <div className="d-flex justify-content-between">
                         <span>Shipping: </span>
                         <span>₹ 700.00</span>
                     </div>
                     <div className="d-flex justify-content-between">
                         <span>Total: </span>
                         <span>₹ 15300.00</span>
                     </div>
                     <div className="d-flex justify-content-between">
                         <span>Promotion Applied: </span>
                         <span>₹ 300.00</span>
                     </div>
                     <div className="d-flex justify-content-between">
                         <span> <b>Grand Total:</b> </span>
                         <span> <b>₹ 15000.00</b></span>
                     </div>
                </div>
            </div>
          </Card>
          <Card className="border border-2 rounded mt-3 h-100">
            <div
              className="d-flex justify-content-between"
              style={{ padding: "10px", marginTop: "10px" }}
            >
              <div style={{ width: "60%" }}>
                <h3 style={{ marginLeft: "20px" }}>
                  Delivered on 27 Nov 2023{" "}
                </h3>
                <div className="d-flex" style={{ marginTop: "10px" }}>
                  <div>
                    <img src={slr36} style={{ width: "150px" }} />
                  </div>
                  <div style={{ marginTop: "10px" }}>
                    <span style={{ fontSize: "17px" }}>SLR 36</span>
                    <br />
                    <span>Return Eligible through 09 Dec 2023</span>
                    <br />
                    <span>Sold by: Monsanto India</span>
                    <br />
                    <span>
                      ₹ <span className="text-danger">15000.00</span>
                    </span>
                    <div style={{ marginTop: "5px" }}>
                      <button
                        className="btn btn-warning"
                      >
                        Buy it again
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div id="buttonContainer" style={{ width: "20%" }}>
                <button
                  className="btn btn-outline-primary"
                  onClick={e => {
                    toggleViewModal(1)
                  }}
                >
                  Track Package
                </button>
                <button
                  className="btn btn-outline-primary"
                  onClick={e => {
                    toggleViewModalForFeedback()
                  }}
                >
                  Leave feedback
                </button>
                <button
                  className="btn btn-outline-primary"
                  onClick={e => {
                    toggleModalForReview()
                  }}
                >
                  Write a product review
                </button>
              </div>
              <div></div>
            </div>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default OrderDetails
